import { createRouter, createWebHistory } from 'vue-router'

// Import pages (we'll create these later)
import Home from '@/views/Home.vue'
import Quote from '@/views/Quote.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'home.title',
      description: 'home.description'
    }
  },
  {
    path: '/quote',
    name: 'Quote',
    component: Quote,
    meta: {
      title: '在線估價',
      description: '線上產品估價系統'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: {
      title: '404.title',
      description: '404.description'
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Global navigation guards
router.beforeEach(async (to, from, next) => {
  // Set page title - we'll handle this in the component itself
  // since useI18n() can only be called in setup functions

  next()
})

export default router